import { Marquee } from "../components/Marquee";

export const ticker = async (symbols) => {
  let count = 0;
  $('.marquee-wrap').addClass('hidden');

  const symbolsRequest = (e) =>
    fetch(`https://api.binance.com/api/v3/ticker/24hr?symbol=${e}`, {})
      .then(res => res.json())
      .then(data => {
        const titleResp = data.symbol;
        const price = data.lastPrice;
        const priceChangePercent = data.priceChangePercent;
        const percentVariable = priceChangePercent > 0 ? 'up' : 'down';

        const title = () => {
          switch (titleResp) {
            case 'BTCUSDT': return 'BTC - USDT';
            case 'ETHUSDT': return 'ETH - USDT';
            case 'ETHBTC': return 'ETH - BTC';
            case 'LINKUSDT': return 'LINK - USDT';
            case 'ADAUSDT': return 'ADA - USDT';
            case 'XTZUSDT': return 'XTZ - USDT';
            case 'VETUSDT': return 'VET - USDT';
            case 'LINKBTC': return 'LINK - BTC';
            case 'SXPUSDT': return 'SXP - USDT';
            case 'SXPBTC': return 'SXP - BTC';
            case 'EOSUSDT': return 'EOS - USDT';
            case 'EOSBTC': return 'EOS - BTC';
            case 'BCHUSDT': return 'BCH - USDT';
            case 'BCHBTC': return 'BCH - BTC';
            default: return titleResp;
          }
        };

        $('#marquee ul').each(function() {
          $(this).append(`
          <li>
            ${title()}
            <span class="marquee__price">${price ? Number(price).toFixed(4) : ''}</span>
            <span class="marquee__percent ${percentVariable}">
              ${priceChangePercent}% <span class="arrow-wrap ${percentVariable}"><i class="arrow ${percentVariable}"></i></span>
            </span>
          </li>
        `);
        });
      })
      .then(() => {
        count = count + 1;

        if (count === symbols.length) {
          $('.marquee-wrap').removeClass('hidden');
          Marquee();
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('[Ticker] Failed to fetch symbol:', e, err);
      });

  symbols.map(e => symbolsRequest(e));
};
